import { QueryKey, useQuery as useReactQuery, UseQueryResult } from '@tanstack/react-query';

import { QueryFn, UseQueryOptions } from './useQuery.types';
import { useClient } from '../useClient/useClient';

export const useQuery = <
  TQueryKey extends QueryKey = unknown[],
  TParams = unknown,
  TError = unknown,
  TResponse = TParams,
>(
  queryKey: TQueryKey,
  query: QueryFn<TQueryKey, TResponse>,
  options?: UseQueryOptions<TResponse, TError, TResponse, TQueryKey>,
): UseQueryResult<TResponse, TError> => {
  const client = useClient();

  return useReactQuery<TResponse, TError, TResponse, TQueryKey>({
    queryKey,
    queryFn: (queryFn) => query(client, queryFn.queryKey),
    ...options,
  });
};
